import styled from "styled-components";

export const SearchInputAreaDefaultBox = styled.input`
    background: transparent;
    color: ${props => props.theme.colors.textLight};
    font-size: 1.5rem;
    cursor: pointer;
    font-weight: 500;
    outline: none;
    border: 2px solid ${props => props.theme.colors.boxBorderLighter};
    border-radius: 4rem;
    transition: width 0.5s ease, padding 0.5s ease;
    &:focus {
        outline: none;
    }
    &::placeholder {
        color: ${props => props.theme.colors.textMiddleDark};
    }

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: 32rem;
        &:focus {
            width: 44rem;
        }
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 100%;
        font-weight: 300;
        &::placeholder {
            color: ${props => props.theme.colors.textLight};
        }
    }
`;